import Image from "../global/Image";
import Link from "next/link";
import imageToURL from "../../lib/utils/imageToURL";
import styles from "./index.module.scss";
const NextProject = ({ nextProject }) => {
  if (typeof nextProject == {}) return <div></div>;
  return (
    <Link href={"/projet/" + nextProject.slug}>
        <footer className={styles.nextProj}>
          <div className={styles.nextProjImage}>
            <Image
              alt="banner-next-project"
              breakpoints={{ medium: null, large: null }}
              image={nextProject.image}
              fit="cover"
            />
          </div>
          <div className={styles.nextProjTitle}>
            <span>Projet Suivant </span>
          </div>
        </footer>
    </Link>
  );
};

export default NextProject;
